// extracted by mini-css-extract-plugin
export default {"root":"amount-field_root-fgAVa"};